import React from 'react';
import zohoStyles from './Zoho.styles';
import ZohoInstruction from './ZohoInstruction';
import { FORM_IDS, INTEGRATION_CONSTANTS, SOURCE_CONSTANTS } from '../constants';
import { getZohoUrl, connectToZoho, getLoadImportData, getFormAndTaxYearList, getFormSetting} from './ZohoSaga';
import { componentKey as zohoComponentKey } from './ZohoSlice';
import { INTEGRATION_ROUTES } from '../../../constants/constants';
import XeroZohoFreshBooksSuiteCommonComponent from '../component/xerozohofreshbookssuitecommoncomponent/XeroZohoFreshBooksSuiteCommonComponent';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';

const sagaActions = {
    getServiceUrl: getZohoUrl,
    connectToService: connectToZoho,
    getLoadImportData,
    getFormAndTaxYearList,
    getFormSetting,
};

export default function Zoho() {
    useGarbageCollector(zohoComponentKey);

    const breadcrumbsItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'Zoho' }
    ];

    return (
        <XeroZohoFreshBooksSuiteCommonComponent
            sagaActions={sagaActions}
            componentKey={zohoComponentKey}
            instructionsComponent={ZohoInstruction}
            integrationConstants={{
                URL_CODE: INTEGRATION_CONSTANTS.URL_CODE,
                URL_SCOPE: INTEGRATION_CONSTANTS.URL_SCOPE,
                URL_ERROR: INTEGRATION_CONSTANTS.URL_ERROR,
                URL_ERROR_DESCRIPTION: INTEGRATION_CONSTANTS.URL_ERROR_DESCRIPTION,
            }}
            sourceConstant={SOURCE_CONSTANTS.ZOHO_SOURCE}
            breadcrumbsItems={breadcrumbsItems}
        />
    );
}
